


































import { Component, Mixins, Prop, Provide } from "vue-property-decorator";
import Context from "@/mixins/context";

@Component
export default class Error extends Mixins(Context) {
  // Props
  @Prop({ default: 404 })
  private code!: number;

  @Provide() private messages: object = {};

  public get title() {
    return this.$t("_.error") + ` ${this.$route.meta?.error || this.code}`;
  }

  public created() {
    this.messages = {
      403: this.$i18n.t("_sentence.you_dont_have_permission_to_access_content"),
      404: this.$i18n.t("_sentence.page_not_found")
    };
  }
}
